import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteTalkingPoint($customerId: ID!, $id: ID!) {
    deleteTalkingPoint(customerId: $customerId, id: $id) {
      id
    }
  }
`;

export const deleteTalkingPoint = async ({
  customerId,
  id,
}: {
  customerId: ID;
  id: ID;
}): Promise<{ id: ID } | null> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, id },
  });
  return getSingleProp(result.data) ?? null;
};
